<script>
import { inventoryMethods, warehouseMethods } from '@state/helpers'
import { mapGetters } from 'vuex'

export default {
  name: 'Title',
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      warehouse_i: 'retina/inventory/warehouse_i',
      ubication_i: 'retina/inventory/ubication_i',
      inventory_count_mode: 'retina/inventory/inventory_count_mode',
      loading_inventory: 'retina/inventory/loading_inventory',
      pending: 'retina/inventory/pending',
    }),
  },
  methods: {
    ...inventoryMethods,
    ...warehouseMethods,
    closeInventoryCountMode() {
      this.clearInventory()
      this.setTotalProducts(0)
      this.setTotalProductsQuantity(0)
      this.clearStock()
      this.setTotalStock(0)
      this.setTotalStockQuantity(0)
      this.clearSpent()
      this.setTotalSpent(0)
      this.clearPending()
      this.setTotalPending(0)
      this.disableInventoryCountMode()
      this.setConsultWarehouse(true)
    },
    goToCountSpentProducts() {
      // * Pasamos todos los productos que estan en inventory a pending. El contenido de inventory lo limpiamos
      this.setPending()
      this.clearInventory()
      this.setTotalProducts(0)
      this.setTotalProductsQuantity(0)
      this.setTotalPending(this.pending.length)
      this.disableInventoryCountMode()
      this.enableInventoryCountSpentProducts()
    },
  },
}
</script>
<template>
  <b-card v-if="inventory_count_mode" no-body class="p-2">
    <span class="text-primary font-weight-lighter">Lugar seleccionado:</span>
    <b-card-title>{{ warehouse_i.description }}</b-card-title>
    <b-card-sub-title class="mb-2 lead">
      {{ ubication_i ? ubication_i.name : "" }}
      <b-badge variant="primary">{{ warehouse_i.code }}</b-badge>
    </b-card-sub-title>
    <b-card-footer footer-bg-variant="transparent" footer-class="p-0 d-flex justify-content-between">
        <b-button-group class="w-100">
          <b-button
            @click="closeInventoryCountMode()"
            variant="outline-danger"
            class="mr-1"
          >
            <i class="fas fa-times"></i> Cancelar
          </b-button>
          <b-button
            @click="goToCountSpentProducts()"
            variant="outline-secondary"
          >
            <i class="fas fa-box-open"></i>
            Consumidos
            <i class="fas fa-chevron-right"></i>
          </b-button>
      </b-button-group>
    </b-card-footer>
  </b-card>
</template>
